export const userConfig = {
  namespaced: true,
  state: {
    accessToken: null,
    refreshToken: null,
    otpId: null,
    loginTempToken: null,
    userPhoneNumber: null,
    deviceIds: null,
    refValue: null,
    userLocation: { id: "" },
    userLoanPhoneNumber: null,
  },
  mutations: {
    setAccessToken(state, payload) {
      state.accessToken = payload;
    },
    setRefreshToken(state, payload) {
      state.refreshToken = payload;
    },
    setOtpId(state, payload) {
      state.otpId = payload;
    },
    setLoginTempToken(state, payload) {
      state.loginTempToken = payload;
    },
    setUserPhoneNumber(state, payload) {
      state.userPhoneNumber = payload;
    },
    setdeviceIds(state, payload) {
      state.deviceIds = payload;
    },
    setRefValue(state, payload) {
      state.refValue = payload;
    },
    setUserLocation(state, payload) {
      state.userLocation = payload;
    },
    setUserLoanPhoneNumber(state, payload) {
      state.userLoanPhoneNumber = payload;
    },
    clearAllConfigs(state) {
      state.accessToken = null;
      state.refreshToken = null;
      state.userPhoneNumber = null;
      state.loginTempToken = null;
      state.otpId = null;
      state.userLoanPhoneNumber = null;
    },
    clearLoginToken(state) {
      state.loginTempToken = null;
      state.otpId = null;
    },
  },
};
